"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleFuturesTPSLUtils = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../interface");
const utils_1 = require("../utils");
var SimpleFuturesTPSLUtils;
(function (SimpleFuturesTPSLUtils) {
    /**
     * 止盈止损按价格转按收益额
     */
    function tpslPriceToProfit(estimatePrice, { order, takerFee }) {
        var _a, _b;
        // quote_amount+ (止盈价格-持仓均价)*(qtyLong+qtyShort)-quote_invest-
        // (transfer_in-transfer_out)-abs((qtyLong+qtyShort))*预估止盈价格*该用户合约Taker手续费率
        return new trade_utils_lib_1.SafeDecimal(order.quote_amount)
            .add(new trade_utils_lib_1.SafeDecimal(estimatePrice)
            .sub((_a = order.active_position_avg_price) !== null && _a !== void 0 ? _a : 0)
            .mul(new trade_utils_lib_1.SafeDecimal(order.qty_long).add(order.qty_short)))
            .sub(order.quote_invest)
            .sub(new trade_utils_lib_1.SafeDecimal(order.transfer_in).sub((_b = order.transfer_out) !== null && _b !== void 0 ? _b : 0))
            .sub(new trade_utils_lib_1.SafeDecimal(order.qty_long).add(order.qty_short).abs().mul(estimatePrice).mul(takerFee));
    }
    SimpleFuturesTPSLUtils.tpslPriceToProfit = tpslPriceToProfit;
    /**
     * 止盈止损按价格转按收益率
     * @param estimatePrice
     * @param order
     * @param takerFee
     */
    function tpslPriceToProfitRate(estimatePrice, { order, takerFee }) {
        return tpslPriceToProfit(estimatePrice, { order, takerFee }).div(order.quote_invest);
    }
    SimpleFuturesTPSLUtils.tpslPriceToProfitRate = tpslPriceToProfitRate;
    /**
     * 止盈止损按收率率转按价格
     */
    function tpslProfitRateToPrice(params) {
        return tpslProfitToPrice(Object.assign(Object.assign({}, params), { tpslProfit: new trade_utils_lib_1.SafeDecimal(params.tpslProfitRate).mul(params.order.quote_invest).toString() }));
    }
    SimpleFuturesTPSLUtils.tpslProfitRateToPrice = tpslProfitRateToPrice;
    /**
     * 止盈止损按收益额转按价格
     */
    function tpslProfitToPrice({ order, tpslProfit, feeRate, }) {
        var _a;
        const qtyNet = utils_1.SimpleFuturesUtils.isWaitingOpenOrder(order)
            ? new trade_utils_lib_1.SafeDecimal(order.quote_invest)
                .mul(order.leverage)
                .div((_a = order.active_position_avg_price) !== null && _a !== void 0 ? _a : 0)
                .mul(order.side === interface_1.CustomOrderSide.BUY ? 1 : -1) // 未触发时前端计算一个qty
            : new trade_utils_lib_1.SafeDecimal(order.qty_long).add(order.qty_short);
        const commonVal = new trade_utils_lib_1.SafeDecimal(order.transfer_in)
            .sub(order.transfer_out || 0)
            .add(order.quote_invest)
            .add(qtyNet.mul(order.active_position_avg_price || 0))
            .sub(order.quote_amount);
        return new trade_utils_lib_1.SafeDecimal(tpslProfit).add(commonVal).div(qtyNet.sub(qtyNet.abs().mul(feeRate.takerFeeRate)));
    }
    SimpleFuturesTPSLUtils.tpslProfitToPrice = tpslProfitToPrice;
    /**
     * 限价单/条件单 开仓时TPSL转换
     */
    function tpslPriceToProfitRate2({ price, side, triggerPrice, leverage, feeRate, }) {
        const sideV = side === interface_1.CustomOrderSide.BUY ? 1 : -1;
        // {收益率}=（止盈or止损价格-挂单价格）*（方向*杠杆倍数/挂单价格）-该用户合约Taker手续费率*2*杠杆倍数
        return new trade_utils_lib_1.SafeDecimal(price)
            .sub(new trade_utils_lib_1.SafeDecimal(triggerPrice))
            .mul(sideV)
            .mul(leverage)
            .div(new trade_utils_lib_1.SafeDecimal(triggerPrice))
            .sub(new trade_utils_lib_1.SafeDecimal(feeRate.takerFeeRate).mul(2).mul(leverage));
    }
    SimpleFuturesTPSLUtils.tpslPriceToProfitRate2 = tpslPriceToProfitRate2;
    /**
     * 限价单/条件单 开仓时TPSL转换
     * 根据{@link tpslPriceToProfitRate2}推算
     */
    function tpslPriceToProfit2(_a) {
        var { invest } = _a, restParams = __rest(_a, ["invest"]);
        return tpslPriceToProfitRate2(restParams).mul(invest);
    }
    SimpleFuturesTPSLUtils.tpslPriceToProfit2 = tpslPriceToProfit2;
    /**
     * 限价单/条件单/市价单 开仓时TPSL转换
     * 根据{@link tpslPriceToProfitRate2}反向推算
     */
    function tpslProfitRateToPrice2({ rate, side, triggerPrice, leverage, takerFee, }) {
        const sideV = side === interface_1.CustomOrderSide.BUY ? 1 : -1;
        return new trade_utils_lib_1.SafeDecimal(rate)
            .add(new trade_utils_lib_1.SafeDecimal(takerFee).mul(2).mul(leverage))
            .div(new trade_utils_lib_1.SafeDecimal(sideV).mul(leverage).div(new trade_utils_lib_1.SafeDecimal(triggerPrice)))
            .add(triggerPrice);
    }
    SimpleFuturesTPSLUtils.tpslProfitRateToPrice2 = tpslProfitRateToPrice2;
    /**
     * 限价单/条件单 开仓时TPSL转换
     * 根据{@link tpslProfitRateToPrice2}推算
     */
    function tpslProfitToPrice2(_a) {
        var { invest, profit } = _a, restParams = __rest(_a, ["invest", "profit"]);
        return tpslProfitRateToPrice2(Object.assign(Object.assign({}, restParams), { rate: new trade_utils_lib_1.SafeDecimal(profit).div(invest).toString() }));
    }
    SimpleFuturesTPSLUtils.tpslProfitToPrice2 = tpslProfitToPrice2;
    /**
     * 当前杠杆及投资额对应的强平时亏损率 M =（本金/投资额+速算额/投资额-杠杆倍数*维持保证金率）/（-维持保证金率-1）
     * @param investInfo
     * @param curLeverageRow
     * @param leverage
     */
    function calcForcedLossRatio({ investInfo, curLeverageRow, leverage, }) {
        return new trade_utils_lib_1.SafeDecimal(investInfo.reverseMargin)
            .add(investInfo.invest)
            .div(investInfo.invest) // 暂时无预留保证金本金=投资额
            .add(new trade_utils_lib_1.SafeDecimal(curLeverageRow.quick_deduction).div(investInfo.invest))
            .sub(new trade_utils_lib_1.SafeDecimal(leverage).mul(curLeverageRow.maint_margin_ratio))
            .div(new trade_utils_lib_1.SafeDecimal(-1).mul(curLeverageRow.maint_margin_ratio).sub(1));
    }
    SimpleFuturesTPSLUtils.calcForcedLossRatio = calcForcedLossRatio;
    /**
     * 快捷获取只有一个简单类型的值(单个收益率/收益额/价格)
     * @param tpOrSLValue
     */
    function tpslValueShortcut(tpOrSLValue) {
        var _a;
        return (_a = tpOrSLValue === null || tpOrSLValue === void 0 ? void 0 : tpOrSLValue.details) === null || _a === void 0 ? void 0 : _a[0].value;
    }
    SimpleFuturesTPSLUtils.tpslValueShortcut = tpslValueShortcut;
    /**
     * 是否有效的TP/SL设置
     * @param tpOrSL
     */
    function isValidTPOrSL(tpOrSL) {
        var _a;
        if (!tpOrSL) {
            return false;
        }
        const shortcutValue = SimpleFuturesTPSLUtils.tpslValueShortcut(tpOrSL);
        return Boolean(shortcutValue) || !new trade_utils_lib_1.SafeDecimal((_a = tpOrSL === null || tpOrSL === void 0 ? void 0 : tpOrSL.trailing) === null || _a === void 0 ? void 0 : _a.draw_down).eq(0);
    }
    SimpleFuturesTPSLUtils.isValidTPOrSL = isValidTPOrSL;
    /**
     * TPSL参数，转换成接口需要的字符串，做一些接口需要的特殊处理
     * @param tpslParams
     */
    function getAPITPSLParamsStr(tpslParams) {
        var _a, _b;
        const profitValid = isValidTPOrSL(tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.profit);
        const lossValid = isValidTPOrSL(tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.loss);
        let str = "";
        if (!profitValid && !lossValid) {
            // 全部取消设置直接传空串
            return str;
        }
        if (profitValid && !!((_b = (_a = tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.profit) === null || _a === void 0 ? void 0 : _a.trailing) === null || _b === void 0 ? void 0 : _b.draw_down)) {
            // 设置了追踪出场
            if (!tpslParams.profit.trailing.trigger_rate) {
                // 兼容后端给成空，避免空串
                tpslParams.profit.trailing.trigger_rate = undefined;
            }
        }
        try {
            str = JSON.stringify(Object.assign(Object.assign({}, tpslParams), { profit: profitValid ? tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.profit : undefined, loss: lossValid ? tpslParams === null || tpslParams === void 0 ? void 0 : tpslParams.loss : undefined, version: "v2" }));
        }
        catch (e) {
            console.error(e);
        }
        return str;
    }
    SimpleFuturesTPSLUtils.getAPITPSLParamsStr = getAPITPSLParamsStr;
    /**
     * 生成发财金预设的TPSL
     * @param bonus
     */
    function createTPSLFromBonus(bonus) {
        return {
            profit: { mode: interface_1.SimpleFutures.TPSLMode.simple_rate, details: [{ value: bonus.profit_stop }] },
            loss: { mode: interface_1.SimpleFutures.TPSLMode.simple_rate, details: [{ value: bonus.loss_stop }] },
        };
    }
    SimpleFuturesTPSLUtils.createTPSLFromBonus = createTPSLFromBonus;
})(SimpleFuturesTPSLUtils = exports.SimpleFuturesTPSLUtils || (exports.SimpleFuturesTPSLUtils = {}));
